export const otherArrangement = {
  arrangementType: {
    etas: "ETAS",
    restaurant_reservation_fee: "Restaurant Reservation Fee",
  },
};
